import parse from 'html-react-parser'

const publication_card = (element) => {
    var title = element['title'];
    var author = element['author'].replaceAll(",","").replaceAll("and",", ");
    author = author.replace("Lou Haowei", "<span class='haowei'>Lou Haowei</span>")
    var journel = element['journal_short'] + ' ' + String(element['year']);
    var link = element['link'];
    return (
        <article className='publication_card' key={title}>
            <a href={link} target="_blank" rel="noreferrer">
                <div className='paper_title'>{title}</div> 
            </a>
            <div className='paper_author'>{parse(author,)}</div>
            <div className='paper_journel'>{journel}</div>
        </article>
    )
}

export default publication_card
